// Human-readable label maps used across admin.
export const STATUS_LABELS = {
  active: "Active",
  draft: "Draft",
  sold_out: "Sold Out",
  archived: "Archived",
};

export const INVENTORY_LABELS = {
  standard: "Standard",
  limited: "Limited",
  one_of_one: "One of One",
};

export const MEDIA_LABELS = {
  "2d": "2D Photos",
  "360": "360° Spin",
  "3d": "3D Model",
  "mixed": "Mixed Media",
};

export const humanStatus = (s) => STATUS_LABELS[s] || s;
export const humanInventory = (s) => INVENTORY_LABELS[s] || s;
export const humanMedia = (s) => MEDIA_LABELS[s] || s;
